import React, { useMemo } from 'react';

// helpers
import { styled } from 'styled-components';
import { FormItemProps } from './types';

// components
import InfoTooltip from 'components/Tooltips/InfoTooltip';
import { Col, Row, Text } from '@ui';
import { Form as AntdForm } from 'antd';

const FormItem: React.FC<FormItemProps> = ({
  className,
  children,
  label,
  labelTooltip,
  labelTooltipPosition = 'top',
  ...rest
}) => {
  const itemLabel = useMemo(() => {
    if (!label) {
      return null;
    }

    if (labelTooltip) {
      return (
        <Row wrap={false} align="middle" gutter={[5, 5]}>
          <Col>
            <Text variant="label1" weight="regular">
              {label}
            </Text>
          </Col>
          <Col>
            <InfoTooltip
              placement={labelTooltipPosition}
              tooltipContent={labelTooltip}
            />
          </Col>
        </Row>
      );
    }

    return (
      <StyledText variant="label1" weight="regular">
        {label}
      </StyledText>
    );
  }, [label, labelTooltip]);

  return (
    <AntdForm.Item className={className} label={itemLabel} {...rest}>
      {children}
    </AntdForm.Item>
  );
};

const StyledText = styled(Text)`
  flex: 1;
`;

export default FormItem;
